import React from 'react';
import {Link} from 'react-router-dom';
import {
    Card, CardBlock, CardGroup, Button,
    ListGroup, ListGroupItem
} from 'reactstrap';

import {api, request, API_URL} from '../../actions/_request';

import Sign from '../../components/sign';

import FaPaperplaneO from 'react-icons/lib/fa/paper-plane-o';

class Term extends React.Component {

	constructor(props) {

		super(props)

		this.state = {
			ticket: { cliente: {}},
			cliente: null,

		};
	}

	componentDidMount() {

		let self = this;
		const {params} = this.props.match;

		if(params.id) {

			api().get('/ticketsv2/'+params.id).then((response) => {

				if(response.status === 200) {

					let data = response.data;

					self.cliente = data.cliente;

					self.setState({ticket: data.ticket});

				}

			});


		}

	}

	sendEmail() {

		
		
	}

	render() {

		const {ticket} = this.state;

		return (
		    <div className="view">
		        <div className="view-content view-pages view-invoice view d-flex justify-content-center align-items-center flex-column">
		            <div className="mb-5">
		                	<Button onClick={this.sendEmail} color="primary" size="lg" block><FaPaperplaneO /> Enviar Documento</Button>
		                </div>
		            <Card className="mb-3 invoice-card">
		                <CardBlock>
		                    <div className="d-flex justify-content-between flex-wrap">
		                        <span style={{color: '#ED0303', fontSize: '27px'}}>Maxicomm</span>
		                        <div>
		                            <h4 className="text-uppercase">Ticket</h4>
		                            <h6>clave: {ticket.clave || '-'}</h6>
		                            <small>Fecha: {ticket.fecha_ticket || '-'}</small>
		                        </div>
		                    </div>
		                    <hr/>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <h5>Maxicomm</h5>
		                                <address>
		                                    Macheros 366, entre 3era.<br/>
		                                    y 4ta., Zona Centro C.P. 22800 <br/>Ensenada, Baja California
		                                    <br/>Tel. (646) 178-8008
		                                </address>
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <h5>{ticket.cliente.cliente || '-'}</h5>
		                                <address>
		                                    {ticket.cliente.contacto || '-'}<br/>
		                                    {ticket.cliente.domicilio || '-'}<br/>{ticket.cliente.ciudad || '-'}
		                                    <br/>Tel. {ticket.cliente.telefono || '-'}
		                                </address>
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <u>Proceso:</u>
										<br/><br/>{ticket.ProcessName || '-'}
										<br/><br/><u>Descripción:</u><br/>
										<span dangerouslySetInnerHTML={{__html: ticket.descripcion || '-'}} />
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <u>Total:</u>
										<br/><br/>$ {ticket.precio}
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <u>Fecha de Pago:</u>
		                                <br/><br/>{ticket.fecha_pago || '---' }
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <u>Factura:</u>
		                                <br/><br/>{ticket.factura || '---' }
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                    <hr/>
		                    {/*<p className="text-warning small text-center"><strong>Note:</strong>This is a computer generated invoice. No Signature Required</p>*/}
		                	<Sign />
		                </CardBlock>
		            </Card>

		        </div>
		    </div>
		)
	}

}


export default Term





// WEBPACK FOOTER //
// ./src/views/ticket/term.js